var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { Input, Button, Pagination, Checkbox, message } from 'antd';
import { default as Icon } from '../icon';
import PinyinMatch from 'pinyin-match';
import DrogField from './drog-field';
import RightDropField from './right-drag-field';
import './index.less';
import { _ } from 'oss-toolkits';
// const isBrowser = typeof window !== 'undefined';
// const { _ } = isBrowser ? require('oss-web-toolkits') : { _: undefined };
const getListStyle = (data) => ({
    overflowY: 'auto',
    width: '100%',
    height: '100%',
});
// 重新记录数组顺序
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    //删除并记录 删除元素
    const [removed] = result.splice(startIndex, 1);
    //将原来的元素添加进数组
    result.splice(endIndex, 0, removed);
    return result;
};
//插入排序
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, removed);
    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
    return result;
};
const filterAciton = (data, list, str) => {
    let flag = false;
    list.forEach((item) => {
        if (PinyinMatch.match(data[item], str)) {
            flag = true;
        }
    });
    return flag;
};
class ColumnsSortDrag extends React.Component {
    constructor(props) {
        super(props);
        this.getRequest = (params) => __awaiter(this, void 0, void 0, function* () {
            let { request, searchParams } = this.props;
            let data = yield request(params);
            let { selectOptionsList } = this.state;
            this.setState({
                allOptionsList: (data === null || data === void 0 ? void 0 : data.data.filter((item) => !selectOptionsList.find((items) => `${item.id}` === `${items.id}`))) || [],
                leftPush: false,
                leftCheckedList: [],
                leftAll: false,
                allLen: (searchParams === null || searchParams === void 0 ? void 0 : searchParams.paging) && (data === null || data === void 0 ? void 0 : data.total)
                    ? data.total
                    : data.data.filter((item) => !selectOptionsList.find((items) => `${item.id}` === `${items.id}`))
                        .length || 0,
            });
        });
        // 拖拽放置函数
        this.onDragEnd = (result) => {
            const { source, destination } = result;
            const { searchParams, maxField, maxFieldMessage } = this.props;
            const { selectOptionsList } = this.state;
            if (!destination) {
                return;
            }
            const sInd = source.droppableId;
            const dInd = destination.droppableId;
            if (maxField &&
                dInd === 'selectOptionsList' &&
                ((sInd === dInd && selectOptionsList.length > maxField) ||
                    (sInd !== dInd && selectOptionsList.length >= maxField))) {
                message.error(maxFieldMessage);
                return;
            }
            if (sInd === dInd) {
                const items = reorder(this.state[sInd], source.index, destination.index);
                this.setState({
                    [sInd]: items,
                }, () => {
                    if (dInd === 'selectOptionsList')
                        this.props.onChange && this.props.onChange(items);
                });
            }
            else {
                const result = move(this.state[sInd], this.state[dInd], source, destination);
                let stateData = {
                    [sInd]: result[sInd],
                    [dInd]: result[dInd],
                    allLen: sInd === 'selectOptionsList' ? result[dInd].length : result[sInd].length,
                };
                if (searchParams.paging) {
                    delete stateData.allLen;
                }
                this.setState(Object.assign({}, stateData), () => {
                    if (dInd === 'selectOptionsList')
                        this.props.onChange && this.props.onChange(result[dInd]);
                    if (sInd === 'selectOptionsList')
                        this.props.onChange && this.props.onChange(result[sInd]);
                });
            }
        };
        this.searchKeyChange = (e) => {
            this.setState({ searchKey: e.target.value });
        };
        this.onSearch = (e) => {
            const { selectOptionsList, leftPagetions } = this.state;
            let { allOptionsList, request, searchParams, columns } = this.props;
            if (request) {
                this.setState({
                    leftPagetions: Object.assign(Object.assign({}, leftPagetions), { pageNum: 1 }),
                }, () => {
                    this.getRequest(Object.assign({ [searchParams.searchField]: e }, this.state.leftPagetions));
                });
                return;
            }
            let list = this.props.allOptionsList
                .filter((item) => !selectOptionsList.find((items) => item.id === items.id))
                .map((item) => {
                let allObj = allOptionsList.find((current) => current.id === item.id);
                if (allObj) {
                    return allObj;
                }
                return item;
            });
            let searchList = columns.filter((item) => item.search).map((item) => item.key);
            if (_.isEmpty(searchList)) {
                searchList = ['name', 'field'];
            }
            let dataList = e ? list.filter((item) => filterAciton(item, searchList, e)) : list;
            this.setState({
                allOptionsList: dataList,
                leftPagetions: Object.assign(Object.assign({}, leftPagetions), { pageNum: 1 }),
                leftPush: false,
                leftCheckedList: [],
                leftAll: false,
                allLen: dataList.length,
            });
        };
        this.onClildrenChange = (data) => {
            const list = this.state[data.stateKey].map((item) => {
                if (`${item.id}` === data.id) {
                    return Object.assign(Object.assign({}, item), { [data.key]: data.value });
                }
                return item;
            });
            this.setState({
                [data.stateKey]: list,
            }, () => {
                this.props.onChange && this.props.onChange(this.state.selectOptionsList);
            });
        };
        this.pageChange = (pageNum, pageSize) => {
            let { searchParams, request } = this.props;
            let { searchKey } = this.state;
            if (request && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.paging)) {
                let params = {
                    [searchParams.searchField]: searchKey,
                    pageNum,
                    pageSize,
                };
                this.getRequest(params);
            }
            this.setState({
                leftPagetions: {
                    pageNum,
                    pageSize,
                },
                leftAll: false,
                leftAllChecked: [],
            });
        };
        this.rightpageChange = (pageNum, pageSize) => {
            this.setState({
                rightPagetions: {
                    pageNum,
                    pageSize,
                },
            });
        };
        this.checkedChangeLeft = (list) => {
            const { allOptionsList, leftPagetions } = this.state;
            const { request, searchParams } = this.props;
            let dataList = [];
            if (request && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.paging)) {
                dataList = allOptionsList;
            }
            else {
                dataList = allOptionsList.filter((item, index) => leftPagetions.pageNum - 1 <= index && leftPagetions.pageNum * leftPagetions.pageSize > index);
            }
            this.props.selectAction && this.props.selectAction(list, 'left');
            if (!_.isEmpty(list)) {
                if (list.length === dataList.length) {
                    this.setState({
                        leftPush: true,
                        leftCheckedList: list,
                        leftAll: true,
                    });
                }
                else {
                    this.setState({
                        leftPush: true,
                        leftCheckedList: list,
                        leftAll: false,
                    });
                }
            }
            else {
                this.setState({
                    leftPush: false,
                    leftCheckedList: list,
                    leftAll: false,
                });
            }
        };
        this.checkedChangeRight = (list) => {
            var _a;
            this.props.selectAction && this.props.selectAction(list, 'right');
            if (!_.isEmpty(list)) {
                if (list.length === ((_a = this.filterSelectOption(this.state.selectOptionsList)) === null || _a === void 0 ? void 0 : _a.length)) {
                    this.setState({
                        rightPush: true,
                        rightCheckedList: list,
                        rightAll: true,
                    });
                }
                else {
                    this.setState({
                        rightPush: true,
                        rightCheckedList: list,
                        rightAll: false,
                    });
                }
            }
            else {
                this.setState({
                    rightPush: false,
                    rightCheckedList: list,
                    rightAll: false,
                });
            }
        };
        this.leftPushChange = () => {
            const { leftCheckedList, selectOptionsList, allOptionsList, leftPagetions } = this.state;
            const { searchParams, maxField, maxFieldMessage } = this.props;
            const data = Array.from(selectOptionsList);
            const leftList = allOptionsList.filter((item) => !leftCheckedList.find((items) => items.id === item.id));
            const index = leftPagetions.pageNum ? (leftPagetions.pageNum - 1) * leftPagetions.pageSize : 0;
            if (maxField && data.length + leftCheckedList.length > maxField) {
                message.error(maxFieldMessage);
                return;
            }
            data.splice(index, 0, ...leftCheckedList);
            let stateData = {
                allOptionsList: leftList,
                selectOptionsList: data,
                leftPush: false,
                leftCheckedList: [],
                leftAll: [],
                leftAllChecked: [],
            };
            if (!searchParams.paging) {
                let stateDataLen = Object.assign(Object.assign({}, stateData), { allLen: leftList.length });
                this.setState(Object.assign({}, stateDataLen), () => {
                    this.props.onChange && this.props.onChange(data);
                });
                return;
            }
            this.setState(Object.assign({}, stateData), () => {
                this.props.onChange && this.props.onChange(data);
            });
        };
        this.rightPushChange = () => {
            const { rightCheckedList, selectOptionsList, allOptionsList, rightPagetions } = this.state;
            const { searchParams } = this.props;
            const data = Array.from(allOptionsList);
            const rightList = selectOptionsList.filter((item) => !rightCheckedList.find((items) => items.id === item.id));
            const index = rightPagetions.pageNum ? (rightPagetions.pageNum - 1) * rightPagetions.pageSize : 0;
            data.splice(index, 0, ...rightCheckedList);
            let stateData = {
                allOptionsList: data,
                selectOptionsList: rightList,
                rightPush: false,
                rightCheckedList: [],
                rightAll: false,
                rightAllChecked: [],
            };
            if (!searchParams.paging) {
                let stateDataLen = Object.assign(Object.assign({}, stateData), { allLen: data.length });
                this.setState(Object.assign({}, stateDataLen), () => {
                    this.props.onChange && this.props.onChange(rightList);
                });
                return;
            }
            this.setState(Object.assign({}, stateData), () => {
                this.props.onChange && this.props.onChange(rightList);
            });
        };
        this.allRightCheckChange = (e) => {
            const { selectOptionsList } = this.state;
            if (e.target.checked) {
                this.setState({
                    rightAllChecked: selectOptionsList,
                    rightAll: e.target.checked,
                });
            }
            else {
                this.setState({
                    rightAllChecked: [],
                    rightAll: e.target.checked,
                });
            }
        };
        this.allLeftCheckChange = (e) => {
            const { allOptionsList, leftPagetions } = this.state;
            const { request, searchParams } = this.props;
            let list = [];
            if (request && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.paging)) {
                list = allOptionsList;
            }
            else {
                list = allOptionsList.filter((item, index) => leftPagetions.pageNum - 1 <= index && leftPagetions.pageNum * leftPagetions.pageSize > index);
            }
            if (e.target.checked) {
                this.setState({
                    leftAllChecked: list,
                    leftAll: e.target.checked,
                });
            }
            else {
                this.setState({
                    leftAllChecked: [],
                    leftAll: e.target.checked,
                });
            }
        };
        // searchKeyRightChange = () => {};
        this.onRightSearch = (e) => {
            this.setState({ rightSearchKey: e });
        };
        this.filterSelectOption = (selectOptionsList) => {
            const { rightSearchKey } = this.state;
            const { columns } = this.props;
            let searchList = columns.filter((item) => item.search).map((item) => item.key);
            if (_.isEmpty(searchList)) {
                searchList = ['name', 'field'];
            }
            let dataList = rightSearchKey
                ? selectOptionsList.filter((item) => filterAciton(item, searchList, rightSearchKey))
                : selectOptionsList;
            return dataList;
        };
        this.state = {
            allOptionsList: props.request
                ? []
                : props.allOptionsList.filter((item) => !props.selectOptionsList.find((items) => `${item.id}` === `${items.id}`)),
            selectOptionsList: props.selectOptionsList,
            PopoverVisible: false,
            searchKey: '',
            leftPagetions: props.leftPagetions || { pageSize: 20, pageNum: 1 },
            rightPagetions: props.rightPagetions || {
                pageSize: 20,
                pageNum: 1,
            },
            leftPush: false,
            rightPush: false,
            leftCheckedList: [],
            rightCheckedList: [],
            rightCheckAll: false,
            rightAllChecked: [],
            rightAll: false,
            leftAll: false,
            leftAllChecked: [],
            allLen: 0,
            rightSearchKey: '',
        };
        this.timer = null;
        this.dragRef = React.createRef();
    }
    // shouldComponentUpdate(nextprops, nextState) {
    //     return;
    // }
    componentDidMount() {
        const { leftPagetions, rightPagetions, allOptionsList } = this.state;
        // let { maxField } = this.props;
        // if (this.props.selectOptionsList.length > maxField) {
        //     message.warning(`已选区域数据超过最大放置数(${maxField}),请减少此区域数据条数`);
        // }
        if (this.dragRef && this.dragRef.current) {
            const dragHeig = parseInt(this.dragRef.current.clientHeight / 35 + '', 10);
            let { request, searchParams } = this.props;
            if (dragHeig > leftPagetions.pageSize) {
                this.setState({
                    leftPagetions: Object.assign(Object.assign({}, leftPagetions), { pageSize: dragHeig }),
                    rightPagetions: Object.assign(Object.assign({}, rightPagetions), { pageSize: dragHeig }),
                    allLen: allOptionsList.length,
                });
            }
            else {
                this.setState({
                    allLen: allOptionsList.length,
                });
            }
            if (request) {
                let params = Object.assign(Object.assign({ [searchParams.searchField]: '' }, leftPagetions), { pageSize: dragHeig });
                this.setState({
                    leftPagetions: Object.assign(Object.assign({}, leftPagetions), { pageSize: searchParams.pageSize ? searchParams.pageSize : dragHeig }),
                });
                this.getRequest(params);
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.selectOptionsList !== prevProps.selectOptionsList ||
            this.props.allOptionsList !== prevProps.allOptionsList) {
            const { searchKey, allOptionsList, allLen, leftPagetions, rightPagetions } = this.state;
            let { request, searchParams } = this.props;
            // if (this.props.selectOptionsList.length > maxField) {
            //     message.warning(`已选区域数据超过最大放置数(${maxField}),请减少此区域数据条数`);
            // }
            if (request) {
                let list = allOptionsList.filter((item) => !this.props.selectOptionsList.find((items) => `${item.id}` === `${items.id}`));
                this.setState({
                    selectOptionsList: this.props.selectOptionsList,
                    allOptionsList: list,
                    allLen: searchParams.paging ? allLen : list.length,
                });
            }
            else {
                let list = this.props.allOptionsList
                    .filter((item) => !this.props.selectOptionsList.find((items) => `${item.id}` === `${items.id}`))
                    .filter((item) => {
                    const { name = '', field = '' } = item;
                    return (searchKey.indexOf(name || field || '') !== -1 ||
                        (name && name.indexOf(searchKey) !== -1) ||
                        (field && field.indexOf(searchKey) !== -1));
                });
                this.setState({
                    allOptionsList: list,
                    selectOptionsList: this.props.selectOptionsList,
                    allLen: list.length,
                    leftPagetions: Object.assign(Object.assign({}, leftPagetions), { pageNum: 1 }),
                    rightPagetions: Object.assign(Object.assign({}, rightPagetions), { pageNum: 1 }),
                    rightCheckedList: [],
                    rightAll: false,
                    rightAllChecked: [],
                });
            }
        }
    }
    render() {
        const { allOptionsList, selectOptionsList, searchKey, leftPagetions, rightPush, rightPagetions, leftPush, rightAllChecked, rightAll, leftAll, leftAllChecked, allLen, } = this.state;
        const { style, columns, allOptionsLabel, selectOptionsLabel, request, searchParams, leftPagetions: propsLeftPagetions, rightPagetions: propsRightPagetions, actionProps, dragHolderMessag, } = this.props;
        const { showLeftSearch = true, showRightSearch = false, showLeftNum = true, showRightNum = true } = actionProps;
        const selectLen = selectOptionsList.length;
        return (<div className="columns-sort-drag" style={style} id="sortDrag">
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <div className="columns-sort-drag-content" style={{ height: '100%' }}>
                        <div className="columns-sort-drag-content-left">
                            <div className="columns-sort-drag-search">
                                <span className="columns-sort-drag-search-title">{allOptionsLabel}</span>
                                {showLeftSearch && (<Input.Search allowClear style={{ flex: 'auto', width: 'auto' }} value={searchKey} onChange={this.searchKeyChange} onSearch={this.onSearch}/>)}
                            </div>
                            <div className="columns-sort-drag-list-new">
                                <div className="columns-sort-drag-list-new-page" style={propsLeftPagetions ? { height: 'calc(100% - 25px)' } : { height: '100%' }}>
                                    <div className="columns-sort-drag-header columns-sort-drag-header-color">
                                        <div className="columns-sort-drag-header-num-empty">
                                            <Checkbox checked={leftAll} onChange={this.allLeftCheckChange}></Checkbox>
                                        </div>
                                        {showLeftNum && <div className="columns-sort-drag-header-num">序号</div>}
                                        {columns &&
                columns
                    .filter((itemss) => !itemss.allOptionsHide)
                    .map((item) => {
                    const style = item.allOptionsWidth
                        ? { width: item.allOptionsWidth }
                        : item.width && {
                            width: item.width,
                        };
                    return (<div className="columns-sort-drag-header-field-info" style={style} key={item.key}>
                                                            {item.title}
                                                        </div>);
                })}
                                    </div>
                                    <div className="columns-sort-drag-list-new-content" ref={this.dragRef}>
                                        <Droppable droppableId="allOptionsList" key="allOptionsList" direction="vertical">
                                            {(provided, snapshot) => (<div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                                                    <DrogField leftPagetions={leftPagetions} students={allOptionsList} columns={columns} checkedChange={this.checkedChangeLeft} leftAllChecked={leftAllChecked} paging={request && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.paging)} showLeftNum={showLeftNum} propsLeftPagetions={propsLeftPagetions}/>
                                                    {provided.placeholder}
                                                </div>)}
                                        </Droppable>
                                    </div>
                                </div>
                                {propsLeftPagetions && (<div className="pagingtions-field">
                                        <Pagination simple current={leftPagetions.pageNum} pageSize={leftPagetions.pageSize} total={allLen} onChange={this.pageChange}/>
                                    </div>)}
                            </div>
                        </div>
                        <div className="columns-sort-drag-direction">
                            <Button size="small" type={leftPush ? 'primary' : 'default'} onClick={this.leftPushChange}>
                                <Icon antdIcon type="RightOutlined" style={leftPush ? { color: '#fff' } : {}}/>
                            </Button>
                            <Button size="small" style={{ marginTop: 10 }} type={rightPush ? 'primary' : 'default'} onClick={this.rightPushChange}>
                                <Icon antdIcon type="LeftOutlined" style={rightPush ? { color: '#fff' } : {}}/>
                            </Button>
                        </div>
                        <div className="columns-sort-drag-content-right">
                            <div className="columns-sort-drag-search">
                                <div className="columns-sort-drag-search-title">{selectOptionsLabel}</div>
                                {showRightSearch && (<Input.Search allowClear style={{ flex: 'auto', width: 'auto' }} 
            // value={rightSearchKey}
            // onChange={this.searchKeyRightChange}
            onSearch={this.onRightSearch}/>)}
                            </div>
                            <div className="columns-sort-drag-list-new">
                                <div className="columns-sort-drag-list-new-page" style={propsRightPagetions ? { height: 'calc(100% - 25px)' } : { height: '100%' }}>
                                    <div className="columns-sort-drag-header columns-sort-drag-header-color">
                                        <div className="columns-sort-drag-header-num-empty">
                                            <Checkbox checked={rightAll} onChange={this.allRightCheckChange}></Checkbox>
                                        </div>
                                        {showRightNum && <div className="columns-sort-drag-header-num">序号</div>}

                                        {columns &&
                columns
                    .filter((item) => !item.selectOptionsHide)
                    .map((item) => {
                    const style = item.selectOptionsWidth
                        ? { width: item.selectOptionsWidth }
                        : item.width && {
                            width: item.width,
                        };
                    return (<div className="columns-sort-drag-header-field-info" style={style} key={item.key}>
                                                            {item.title}
                                                        </div>);
                })}
                                    </div>
                                    <div className="columns-sort-drag-list-new-content">
                                        <Droppable droppableId="selectOptionsList" direction="vertical" key="selectOptionsList">
                                            {(provided, snapshot) => (<div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                                                    <RightDropField rightAllChecked={rightAllChecked} students={this.filterSelectOption(selectOptionsList)} rightPagetions={rightPagetions} columns={columns} showRightNum={showRightNum} onClildrenChange={this.onClildrenChange} checkedChange={this.checkedChangeRight} propsRightPagetions={propsRightPagetions} dragHolderMessag={dragHolderMessag}/>
                                                    {provided.placeholder}
                                                </div>)}
                                        </Droppable>
                                    </div>
                                </div>
                                {propsRightPagetions ? (<div className="pagingtions-field">
                                        <Pagination simple current={rightPagetions.pageNum} pageSize={rightPagetions.pageSize} total={selectLen} onChange={this.rightpageChange}/>
                                    </div>) : null}
                            </div>
                        </div>
                    </div>
                </DragDropContext>
            </div>);
    }
}
ColumnsSortDrag.propTypes = {
    // 所有选择项
    allOptionsList: PropTypes.array,
    // 需要展示的项
    selectOptionsList: PropTypes.array,
    // 左右项的名字
    allOptionsLabel: PropTypes.string,
    selectOptionsLabel: PropTypes.string,
    // 表头，列类目
    columns: PropTypes.array,
    // 拖拽传递抛出展示项list集合
    onChange: PropTypes.func,
    style: PropTypes.object,
    paging: PropTypes.bool,
    searchParams: PropTypes.object,
    request: PropTypes.func,
};
// allOptionsList/columns 格式
/**
 * allOptionsList/columns格式
 * {
    id: 1 //主键不能重复 必填字段,
    name: '张三',
    field: 'zhangsan',
    alais:'狗蛋',
    width:'100'
    },
 */
/**
 * columns 表头
 * 序号不在columns管理范围内，不支持重写
 * 默认值 (名称、字段、别名、宽)度自定义字段
 * 数据格式
 * {
 *    key:'1' 字符串类型，必填字段,不能重复 和table相同
 *    title:'张三' 字符串类型,
 *    editFlag:false, //是否允许修改，修改为气泡窗的形式
 *    allOptionsHide:true  //boolean值类型  true的时候所有字段区域不展示该字段，默认为false 展示
 *    selectOptionsHide:true //boolean值类型 true的时候展示字段区域不展示改字段，默认为false 展示
 *    width:80  //自定义列宽属性通用属性，影响两边
 *    allOptionsWidth //所有字段区域列宽属性，设置此属性 通用width属性在此处失效
 *    selectOptionsWidth //展示字段区域列宽属性，设置此属性 通用width属性在此处失效
 * }
 */
/**
 * request返回值类型为promise
 * resolve的结果数据格式
 * {
 *      data:[] 数据返回值集合,
 *      total:0 数据总量条数，如数据后端进行分页时传递，如后端为全量数据请传递null
 * }
 */
ColumnsSortDrag.defaultProps = {
    allOptionsList: [],
    selectOptionsList: [],
    allOptionsLabel: '所有字段',
    selectOptionsLabel: '展示字段',
    columns: [],
    onChange: () => { },
    style: {},
    paging: true,
    showRightPagination: false,
    searchParams: {
        searchField: 'word',
        paging: false,
    },
    leftPagetions: {
        pageSize: 20,
        pageNum: 1,
    },
    rightPagetions: false,
    actionProps: { showLeftSearch: true, showRightSearch: false, showLeftNum: true, showRightNum: true },
    maxFieldMessage: '超过最大放置数',
    dragHolderMessag: false,
};
export default React.memo(ColumnsSortDrag);
